
import { EventRoleBadge } from "./EventRoleBadge";
import { UrgencyBadge } from "./UrgencyBadge";
import { useEventDeadline } from "@/hooks/useEventDeadline";

interface EventCardHeaderProps {
  title: string;
  isHost: boolean;
  deadline?: string | null;
  guestRsvpComplete?: boolean;
  hasRecommendations?: boolean;
  rsvpStatus?: 'invited' | 'accepted' | 'declined' | 'maybe';
}

export const EventCardHeader = ({ 
  title, 
  isHost, 
  deadline,
  guestRsvpComplete = true,
  hasRecommendations = false,
  rsvpStatus
}: EventCardHeaderProps) => {
  const { showBadge } = useEventDeadline(
    deadline || null,
    !!guestRsvpComplete,
    !!hasRecommendations
  );

  return (
    <>
      <h2 className="text-lg font-semibold">{title}</h2>
      <div className="flex flex-wrap items-center gap-2 mt-1">
        <EventRoleBadge isHost={isHost} rsvpStatus={rsvpStatus} />
        
        {showBadge && deadline && (
          <UrgencyBadge 
            deadline={deadline} 
            label="to RSVP" 
            guestRsvpComplete={guestRsvpComplete}
            hasRecommendations={hasRecommendations}
          />
        )}
      </div>
    </>
  );
};
